import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { carrierActions } from 'store';
import { CustomNumericFormat, FullTable, MinLoader, PriceRow, TabButtons } from 'components';
import {
  VENDORS_RESERVE_ACTION_TYPE,
  GET_RESERVE,
  vendorsReserveBody,
  vendorsReserveHead,
  factoredVendorsReserveHead, factoredVendorsReserveBody,
} from './constants';
import { Colors, Images, isFactored } from 'utils';
import { reserveTabParams, reserveTabTypeEnums } from '../../fragments/carriers/carrierInfo/core/constants';

export const VendorReserve = ({}) => {
  const { allReserves, reserveList } = useSelector((state) => ({
    reserveList: state.carriers.reserveList,
    allReserves: state.carriers.allReserves,
  }));
  const dispatch = useDispatch();
  const history = useHistory();
  const info = history?.location?.state;
  const userInfo = JSON.parse(localStorage.getItem('poloUserInfo'));
  const renderParams = () => {
    const filteredInfo = {
      ...info,
    };
    filteredInfo.state = info?.viewType ?  info?.viewType : reserveTabTypeEnums.PENDING;
    delete filteredInfo.viewType;
    filteredInfo.skip = info?.skip ? info?.skip : 0;
    filteredInfo.limit = 100;
    delete filteredInfo.page;
    delete filteredInfo.activeTab;
    return filteredInfo;
  };

  useEffect(() => {
    handleGet('loading');
    const interval = setInterval(() => {
      handleGet('noLoad');
    }, 30000);
    return () => clearInterval(interval);
  }, [info]);


  const handleGet = (loading) => {
    const loader = loading === 'loading' ? 'loading' : 'noLoad';
    const filteredInfo = renderParams();

    if(isFactored){
      dispatch(carrierActions.getReserve(userInfo?.id, { ...filteredInfo }, loader));
    }else{
      dispatch(carrierActions.getAllReserves({ ...filteredInfo }, loader));
    }
  };

  return (
    <div>
      <TabButtons
        tabParams={reserveTabParams}
        resetParams={true}
        resetSaveParams={{
          activeTab: info?.activeTab
        }}
      />

      <div className="reserve-wrapper">
        <p className="reserve-total-title">Totals</p>

        <div className="align-center" style={{ gap: 16 }}>
          <div className="reserve-row-box active-reserve" style={{ minWidth: 250 }}>
            <p className="reserve-row-title">Reserve:</p>
            <p className="reserve-row-value">
              <PriceRow info={isFactored ? reserveList?.total : allReserves?.total} />
              {/*<PriceRow info={carrierById?.reserve?.keptAmount} />*/}
            </p>
          </div>
        </div>
      </div>

      <FullTable
        head={isFactored ? factoredVendorsReserveHead(info?.viewType) : vendorsReserveHead}
        body={isFactored ? factoredVendorsReserveBody(info?.viewType) : vendorsReserveBody}
        loadingType={isFactored ? GET_RESERVE : VENDORS_RESERVE_ACTION_TYPE}
        list={isFactored ? reserveList?.loads : allReserves?.carriers}
        listCount={isFactored ? reserveList?.count : allReserves?.count}
        noText={'Vendors Reserve'}
      />
    </div>
  );
};